export const SERVER_URL = "https://subscription-application.herokuapp.com"
// export const SERVER_URL = "http://localhost:8080"